"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterTweetEmbed1Schema = void 0;
exports.TwitterTweetEmbed1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/twitter-socialembed/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TwitterTweetEmbed1",
    "description": "Embed a twitter tweet",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:twitter-socialembed:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "hideCards": {
                    "type": "boolean",
                    "default": false
                },
                "hideConversation": {
                    "type": "boolean",
                    "default": false
                },
                "tweetId": {
                    "type": "string",
                    "description": " The tweet id can be obtained by clicking on the date of a tweet, the last path fragment of the url in the browser address bar is the id. (e.g. 560070183650213889)"
                },
                "widgetType": {
                    "type": "string",
                    "default": "tweet",
                    "enum": [
                        "tweet",
                        "video"
                    ]
                }
            },
            "required": [
                "hideCards",
                "hideConversation",
                "tweetId",
                "widgetType"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90d2l0dGVyLXNvY2lhbGVtYmVkLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsS0FBSyxFQUFFLHdGQUF3RjtJQUMvRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxvQkFBb0I7SUFDN0IsYUFBYSxFQUFFLHVCQUF1QjtJQUN0QyxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sZ0RBQWdEO2FBQ2pEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osV0FBVyxFQUFFO29CQUNYLE1BQU0sRUFBRSxTQUFTO29CQUNqQixTQUFTLEVBQUUsS0FBSztpQkFDakI7Z0JBQ0Qsa0JBQWtCLEVBQUU7b0JBQ2xCLE1BQU0sRUFBRSxTQUFTO29CQUNqQixTQUFTLEVBQUUsS0FBSztpQkFDakI7Z0JBQ0QsU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUscUtBQXFLO2lCQUNyTDtnQkFDRCxZQUFZLEVBQUU7b0JBQ1osTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLFNBQVMsRUFBRSxPQUFPO29CQUNsQixNQUFNLEVBQUU7d0JBQ04sT0FBTzt3QkFDUCxPQUFPO3FCQUNSO2lCQUNGO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsV0FBVztnQkFDWCxrQkFBa0I7Z0JBQ2xCLFNBQVM7Z0JBQ1QsWUFBWTthQUNiO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=